import React, { useContext } from "react";
import AppContext from "../../contexts/appContext";
import SelectableButton from "../ui/SelectableButton/selectableButton";
import styles from "./accountList.module.sass";
import { parseCC } from "../../utils/accounts";

const accountList = (props) => {
  const context = useContext(AppContext);

  return (
    <ul className={styles.AccountList}>
      {context.ibcUser &&
        context.ibcUser.accounts.map((cc, index) => {
          const data = parseCC(cc);
          return (
            <li key={`${cc}-${index}`} className={styles.AccountItem}>
              <SelectableButton
                selected={index === props.selectedIndex}
                className={styles.AccountButton}
                blue
                showCheckmark
                onClick={() => {
                  props.onChange({
                    accountIndex: index,
                    anotherAccount: false,
                    operation: data.operation,
                    agency: data.agency,
                    account: data.account,
                    digit: data.dv,
                  });
                }}
              >
                {`Ag: ${data.agency} CC: ${data.account}-${data.dv}`}
              </SelectableButton>
            </li>
          );
        })}
      <li key={"outra"} className={styles.AccountItem}>
        <SelectableButton
          selected={props.selectedIndex === context.ibcUser.accounts.length}
          className={styles.AccountButton}
          blue
          showCheckmark
          onClick={() => {
            props.onChange({
              accountIndex: context.ibcUser.accounts.length,
              anotherAccount: true,
              operation: "",
              agency: "",
              account: "",
              digit: "",
            });
          }}
        >
          Outra Conta
        </SelectableButton>
      </li>
    </ul>
  );
};

export default accountList;
